import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import { filterCategories } from 'src/areas/landing-page/filter-categories';
import { NewProductRecommendationsFragment, Product } from 'src/types';
import { ProductsSection } from '../products-section';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';
import { NEW_PRODUCT_CLICK } from 'src/globals/helpers/navigation-action';
import { productNavigation } from 'src/areas/product/actions/product';

type Props = {
  newReleases?: Recommendations['newReleases'];
  landingPage?: boolean;
};

type Recommendations = NonNullable<
  NewProductRecommendationsFragment['newProductRecommendations']
>;

const NewProductReleases: React.FC<Props> = props => {
  const { newReleases: newProducts = { nodes: [] }, landingPage } = props;
  const { t } = useContext(AppContext);
  const dispatch = useDispatch();

  if (!(newProducts && newProducts.nodes) || !newProducts.nodes.length) {
    return null;
  }

  const newProductsItems = filterCategories(newProducts.nodes as Product[]);

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.NEW_PRODUCT_RELEASES_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    dispatch(productNavigation(NEW_PRODUCT_CLICK, data.index + 1));
    trackInternalNavigationClick({
      scope: InternalNavigationScope.NEW_PRODUCT_RELEASES_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ProductsSection
      products={newProductsItems}
      title={t('landing', 'personalized-releases.title')}
      shouldLazyLoadImages
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
      landingPage={landingPage}
    />
  );
};

export default NewProductReleases;
